import { H2 } from '../Headings';

export const StyledCardTitle = H2.withComponent('p');
